import React from "react";

export default function AppLogo() {
  return (
    <div className="xl:w-[274px] w-[174px] h-[38px]">
      <img src="/hero/hero-logo.svg" alt="/" />
    </div>
  );
}